
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname, DateHelper, StringHelper } from "@rivtn/noseur";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { i18nManager } from "../../../../../i18n";
import { IMember, IProfileWebsite } from "../../../../../services";
import { activeMedia, pagePath, visiblePages } from "../../helpers";

export interface FooterProps {
    basePath: string;
    profile?: IMember;
    website: IProfileWebsite;
}

function Footer({ website, basePath, profile }: FooterProps) {

    const labels = i18nManager.Labels;
    const logo = activeMedia(website, "LOGO");
    const today = DateHelper.getStartOfDay();
    const owner = website.owns_copyright ? website.display_name : labels.omnehost;
    const socials = Object.entries(website.member.social_accounts ?? {});
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const dashboardUrl = process.env.REACT_APP_OMNEHOST_DASHBOARD_URL ?? "http://127.0.0.1:3901";

    return (<footer className={styles["footer"]}>
        <div className={styles["container"]}>
            <div className={styles["footer-grid"]}>
                <div className={styles["footer-brand"]}>
                    <div className={styles["footer-logo"]}>
                        {(website.owns_copyright && logo)
                            ? (<img className={styles["nb-crest"]} src={logo} alt={website.display_name} />)
                            : (<div className={styles["nb-crest"]}>{owner.charAt(0)}</div>)}
                        <span>{owner}</span>
                    </div>
                    {(website.owns_copyright && website.member.tagline) && (<div className={styles["footer-tagline"]}>"{website.member.tagline}"</div>)}
                    <p className={styles["footer-desc"]}>{website.owns_copyright ? website.profile_detail : labels.omnehost_detail}</p>
                </div>

                <div>
                    <div className={styles["footer-col-title"]}>{labels.landing.navigation}</div>
                    {visiblePages(website).map(([page, pageSettings]) => (
                        <ReactRouterDom.NavLink end key={page} to={{ pathname: pagePath(basePath, page), search: searchParams.toString() }}
                            className={({ isActive }) => Classname.build(styles["footer-link"], { [styles["active"]]: isActive })}>{pageSettings.label}</ReactRouterDom.NavLink>
                    ))}
                </div>

                <div>
                    <div className={styles["footer-col-title"]}>{labels.landing.connect}</div>
                    {socials.map(([social, username]) => (
                        <ReactRouterDom.NavLink key={social} target="_blank" className={styles["footer-link"]} to={Utils.getSocialLink(social, username)}>{StringHelper.toSaneSentenceFormat(social)}</ReactRouterDom.NavLink>
                    ))}
                </div>

                {(!website.owns_copyright) && (<div>
                    <div className={styles["footer-col-title"]}>{labels.omnehost}</div>
                    <ReactRouterDom.NavLink target="_blank" className={styles["footer-link"]} to={dashboardUrl}>{profile ? labels.auth.dashboard : labels.auth.sign_in}</ReactRouterDom.NavLink>
                    {labels.footer.map((f) => (
                        <ReactRouterDom.NavLink key={f.label} target="_blank" className={styles["footer-link"]} to={f.location}>{f.label}</ReactRouterDom.NavLink>
                    ))}
                </div>)}
            </div>

            <div className={styles["footer-bottom"]}>
                <span>© {today.getFullYear()} {owner}. {labels.landing.all_r_reserved}</span>
                <div className={styles["footer-socials"]}>
                    {Object.entries(website.owns_copyright ? (website.member.social_accounts ?? {}) : Utils.OMNEHOST_SOCIALS).map(([social, username]) => (
                        <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username)} className={styles["footer-social"]}><i className={Utils.getSocialIcon(social)} /></ReactRouterDom.NavLink>
                    ))}
                </div>
            </div>
        </div>
    </footer>);
}

export default Footer;
